// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"f3dd8037","513":"24b1cfc4","703":"b8f42e66"}[chunkId] + ".chunk.js";
};